import styled from 'styled-components';
import ActionButton from '../Action/ActionButton';
import StyledIcon from '@/atoms/Icon/styles';
import {StyledFollowButtonProps} from './typings';

const iconMargin = {
  text: 0,
  small: 1,
  default: 2,
};

export const StyledFollowButton = styled(ActionButton)<StyledFollowButtonProps>`
  ${StyledIcon} {
    margin-top: ${(props) => iconMargin[props.$size]}px;
  }
`;
